import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import InverterSpecs from "./pages/InverterSpecs";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Devices from "./pages/Devices";
import Reports from "./pages/Reports";
import Admin from "./pages/Admin";
import Settings from "./pages/Settings";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Profile from "./pages/Profile";
import Alerts from "./pages/Alerts";

function ProtectedRoute({ children }) {

    const token = localStorage.getItem("token");

    if (!token)
        return <Navigate to="/login" />;

    return children;
}

export default function App() {

    return (

        <BrowserRouter>

            <Routes>

                <Route
                    path="/login"
                    element={<Login />}
                />

                <Route
                    path="/register"
                    element={<Register />}
                />

                <Route
                    path="/forgot-password"
                    element={<ForgotPassword />}
                />

                <Route
                    path="/reset-password"
                    element={<ResetPassword />}
                />

                <Route path="/reports" element={<Reports />} />

                {/*
                    No ProtectedRoute here on purpose - this isn't a user
                    account page. Admin.jsx gates itself behind the admin
                    password/token, completely separate from user login.
                    Not linked anywhere in the app; reachable only by typing
                    /admin directly.
                */}
                <Route path="/admin" element={<Admin />} />
                <Route
                    path="/specs"
                    element={
                        <ProtectedRoute>
                            <InverterSpecs />
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/devices"
                    element={
                        <ProtectedRoute>
                            <Devices />
                        </ProtectedRoute>
                    }
                />
                <Route
    path="/alerts"
    element={
        <ProtectedRoute>
            <Alerts />
        </ProtectedRoute>
    }
/>
                <Route
                    path="/settings"
                    element={
                        <ProtectedRoute>
                            <Settings />
                        </ProtectedRoute>
                    }
                />
                <Route
    path="/profile"
    element={
        <ProtectedRoute>
            <Profile />
        </ProtectedRoute>
    }
/>
                <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <Dashboard />
                        </ProtectedRoute>
                    }
                />

            </Routes>

        </BrowserRouter>

    );
}
